export const iconFontAwesomeCharityCircleDollarToSlot = (
	<i className="fa-solid fa-circle-dollar-to-slot"></i>
);
